module.exports = __webpack_public_path__ + "static/img/product-top-2.6d678e03.png";